import { enableProdMode } from '@angular/core'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'

import { AppModule } from './app/app.module'
import { environment } from './environments/environment'

if (environment.production) {
  enableProdMode()
}

// Genie mode (embedded as iframe in stacks-chat): persist the credentials from the
// URL BEFORE Angular bootstraps, so every service constructor reads the fresh
// token/project from localStorage. This replaces the old window.location.reload()
// in AppComponent, which double-loaded the whole app on every token/project change.
const genieParams = new URLSearchParams(window.location.search)
if (genieParams.get('genie') === 'true' && genieParams.get('token') && genieParams.get('projectId')) {
  localStorage.setItem('source', 'genie')
  localStorage.setItem('token', genieParams.get('token')!)
  localStorage.setItem('selectedProject', genieParams.get('projectId')!)
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err))
